import React from 'react';
import { 
  Grid,
	GridColumn,
	GridRow,
	Image,
} from 'semantic-ui-react';

export default function OurWorkImages() {

	const imageStyle = {
    borderRadius: "1em",
		height: "20em",
		width: "100%",
		objectFit: "cover",
  }

  return (
		<div style={{ background: "#C2CDBE" }}>
			<Grid 
				columns={3} 
				centered 
				container 
				doubling 
				stackable
				style={{
					padding: "0em 1em 10em 1em",
				}}
			>
				<GridRow>
					<GridColumn>
						<Image
							src="./macrocarpaPineBlueResinDiningTable.webp"
							title="Macrocarpa pine and blue resin dining table (3.2 metres long)"
							alt="Macrocarpa pine and blue resin dining table (3.2 metres long)"
							style={imageStyle}
						/>
					</GridColumn>
					<GridColumn>
						<Image
							src="./blackheartSassafrasGreenResinTimberBoard.webp"
							title="Blackheart sassafras & lime green resin serving board"
							alt="Blackheart sassafras & lime green resin serving board"
							style={imageStyle}
						/>
					</GridColumn>
					<GridColumn>
						<Image
							src="blackwoodButchersBlock.webp"
							title="Blackwood butchers block"
							alt="Blackwood butchers block"
							style={imageStyle}
						/>
					</GridColumn>
				</GridRow>
			</Grid>
		</div>
  );
};